import React from 'react';
import Card from 'components/Card/Card';
import { Divider, Typography } from 'antd';
import { FAMILY_BRANCH_MAP } from 'containers/Family/AddApplication2/familyApplicationConstants';

export default function MilitaryChildCareInstructions({ application, household }) {
  return (
    <div className="mb-6">
      <Card color="success" title="We're here to help:" className="mt-6 bg-white">
        <div className="my-2">
          <h3 className="text-xl font-semibold">What happens next?</h3>
          <ul className="mt-2 mb-4 ml-8 list-disc">
            <li>You will receive an email with your family’s ID number</li>
            <li>
              Email missing documents to{' '}
              <a href="mailto:msp@usa.childcareaware.org" className="underline hover:underline">
                msp@usa.childcareaware.org
              </a>
              <Typography.Text className="block text-sm">(Self-service document upload coming soon)</Typography.Text>
            </li>
          </ul>

          <Divider />

          <h3 className="mt-8 text-xl font-semibold">Questions? 1-800-424-2246</h3>
          <ul className="mt-2 ml-8 list-disc">
            <li>Army: Option 1</li>
            <li>Air Force/Space Force: Option 3</li>
            <li>Marine Corps: Option 4</li>
            <li>
              {application?.applicant?.militaryDetails?.branch?.id === FAMILY_BRANCH_MAP.army.id
                ? '8am-7pm EST'
                : '9am-7pm EST'}
            </li>
          </ul>
        </div>
      </Card>
    </div>
  );
}
